import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  Stack,
  Text,
  IconButton,
  DefaultButton,
} from "@fluentui/react";
import { DataGrid, DataGridColumn } from "../../ui-controls/DataGrid";
import ShimmerList from "../../ui-controls/ShimmerList";
import { getPasswordResetAudits, PasswordResetAuditDto } from "../../api/passwordReset";

const PasswordResetAuditsPage = () => {
  const navigate = useNavigate();
  const [audits, setAudits] = useState<PasswordResetAuditDto[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchAudits = useCallback(() => {
    setLoading(true);
    getPasswordResetAudits()
      .then((data) => setAudits(data || []))
      .catch(() => setAudits([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchAudits();
  }, [fetchAudits]);

  const columns: DataGridColumn[] = [
    {
      key: "dateChanged",
      name: "Date",
      minWidth: 160,
      maxWidth: 200,
      onRender: (item: PasswordResetAuditDto) =>
        new Date(item.dateChanged).toLocaleString(),
    },
    {
      key: "companyId",
      name: "Company ID",
      fieldName: "companyId",
      minWidth: 90,
      maxWidth: 110,
      isResizable: true,
    },
    {
      key: "companyName",
      name: "Company Name",
      fieldName: "companyName",
      minWidth: 160,
      maxWidth: 240,
      isResizable: true,
    },
    {
      key: "databaseLetter",
      name: "Database",
      fieldName: "databaseLetter",
      minWidth: 80,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "userName",
      name: "Username",
      fieldName: "userName",
      minWidth: 120,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "requestedBy",
      name: "Reset By",
      fieldName: "requestedBy",
      minWidth: 180,
      maxWidth: 280,
      isResizable: true,
    },
  ];

  return (
    <Stack tokens={{ childrenGap: 8 }} styles={{ root: { padding: "16px" } }}>
      <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 12 }}>
        <DefaultButton
          iconProps={{ iconName: "Back" }}
          text="Back"
          onClick={() => navigate("/password-reset")}
        />
        <Text variant="xLarge" styles={{ root: { fontWeight: 600 } }}>
          Password Reset Audits
        </Text>
        <div style={{ flex: 1 }} />
        <IconButton
          iconProps={{ iconName: "Refresh" }}
          title="Refresh"
          onClick={fetchAudits}
          disabled={loading}
        />
      </Stack>

      {loading ? (
        <ShimmerList numberOfColumns={6} />
      ) : (
        <DataGrid items={audits} columns={columns} />
      )}
    </Stack>
  );
};

export default PasswordResetAuditsPage;
